import { useState } from "react";
import { Alert } from "@mui/material";
import { bulkUploadHealthZip } from "../../services/labourLaw";
import { toast } from "react-toastify";
import useLoader from "../../hooks/useLoader";
import useModal from "../../hooks/useModal";

  const BulkHealthUpload = ({ onSuccess }) => {
  const { showLoader, hideLoader } = useLoader();
  const { showModal, hideModal} = useModal();

  const [zipFile, setZipFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (!file.name.toLowerCase().endsWith(".zip")) {
      toast.error("Only ZIP files are allowed");
      e.target.value = "";        // reset input
      setZipFile(null);
      return;
    }

    setZipFile(file);
  };

  const handleSubmit = async () => {
    try {
      if (!zipFile) return;

      showLoader();
      setLoading(true);

      const formData = new FormData();
      formData.append("zip", zipFile);

      const res = await bulkUploadHealthZip(formData);

      const invalidFiles = res.data?.data?.invalidFiles || [];

      if (invalidFiles.length > 0) {
        showModal(
          "Invalid Health Check Files",
          <div>
            <p className="fw-bold text-danger mb-2">
              Some files were skipped:
            </p>
            <ul>
              {invalidFiles.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>
        );
      }else{
        hideModal();
      }

      if (res.data?.data?.totalProcessed > 0) {
        toast.success("Health details saved successfully");
        onSuccess();
      }

    } catch (err) {
      toast.error("Health details Zip Upload failed");
    } finally {
      hideLoader();
      setLoading(false);
    }
  };


  return (
    <>
      <Alert severity="info" className="mb-3">
        ZIP file upload only. Inside Zip only PDF files Allowed
        <br />
        <b>PDF format:</b> <b>EMPCODE_YEAR.pdf</b>
        <br />
        Example: <code>453225_2025.pdf</code>
      </Alert>

      <input
        type="file"
        accept=".zip"
        className="form-control"
        onChange={handleFileChange}
      />

      <div className="text-end mt-3">
        <button
          className="btn btn-success"
          disabled={!zipFile || loading}
          onClick={handleSubmit}
        >
          {loading ? "Processing..." : "Upload & Process"}
        </button>
      </div>
    </>
  );
};

export default BulkHealthUpload;
